module.exports = __webpack_public_path__ + "3e9ec10697d8a01d80f9d9d8a0d78d28.svg";